import { render, staticRenderFns } from "./IconCaretAsc.vue?vue&type=template&id=70a015ae&"
import script from "./IconCaretAsc.vue?vue&type=script&lang=js&"
export * from "./IconCaretAsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports